"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHeroSection() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="243038" id="dialogo-internazionale" className="relative dark bg-background py-20 md:py-28 lg:py-32 overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 opacity-20 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/global_nexus_map.png)] bg-cover bg-center mix-blend-screen pointer-events-none"></div>
      
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/40 to-transparent pointer-events-none"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
        <div ref={headerRef} className={`max-w-3xl mx-auto transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground font-default mb-6 tracking-tighter">
            Contattaci <span className="text-primary mx-2">/</span> Contact Us
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl mx-auto leading-relaxed">
            Pronti ad assistervi in ogni fase della mobilità internazionale, offrendo consulenza professionale e supporto dedicato per visti, immigrazione, pratiche nazionali  e  internazionali.
          </p>
          
          {}
          <div className="w-24 h-1 bg-primary mx-auto mt-8 rounded-none opacity-100 shadow-[0_0_15px_rgba(255,215,0,0.5)]"></div>
        </div>
      </div>
    </section>;
}